export default[
    {
        path: 'consultorias/control-actividades-jefatura',
        name: 'ControlActividadesJefatura',
        component: () => import('../control-actividades-jefatura/views/index.vue'),
    },
    {
        path: 'consultorias/control-actividades-jefatura/detalle/:id',
        name: 'DetalleControlActividades',
        component: () => import('../control-actividades-jefatura/views/DetalleControlActividades.vue'),
    },
    {
        path: 'consultorias/control-actividades-jefatura/actividades',
        name: 'ControlActividadesView',
        component: () => import('../control-actividades-jefatura/views/controlActividadesView.vue'),
    }
]